import script from "./AdvantagesSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvantagesSlide.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__